<template>
  <section class="main-project-carousel">
    <div class="project-carousel-inner">
      <div class="project-carousel-container">
        <div v-for="(project, index) of data.projects" :key="index" class="project-carousel-card">
          <a :href="`/project/${project.post_name}`" @click.prevent="goToProject(project)" class="project-carousel-card-link">
            <img
              :src="getProjectImage(project)"
              :alt="project.post_title"
              class="project-carousel-image"
            />
            <div class="project-carousel-overlay"></div>
            <div class="project-carousel-info">
              <h3 v-html="project.post_title"></h3>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps(['data'])

const getProjectImage = (project) => {
  // Prefer the enriched featured image from our REST API filter
  if (project.featured_image?.full) return project.featured_image.full
  if (project.featured_image?.large) return project.featured_image.large
  // Fallback to ACF gallery if available
  if (project.acf?.['acf-single-portfolio-gallery']?.[0]?.url) {
    return project.acf['acf-single-portfolio-gallery'][0].url
  }
  return ''
}

const goToProject = (project) => {
  // Projects are handled by WordPress, not Vue router
  window.location.href = `/project/${project.post_name}`
}

onMounted(() => {
  ScrollTrigger.matchMedia({
    '(min-width: 960px)': function () {
      gsap.fromTo('.project-carousel-container',
        { x: 0 },
        {
          scrollTrigger: {
            id: 'project-carousel-container',
            trigger: '.project-carousel-container',
            start: 'center bottom',
            scrub: true,
            markers: false
          },
          x: '-30%'
        })
    }
  })
})

onBeforeUnmount(() => {
  const carouselContainer = ScrollTrigger.getById('project-carousel-container')
  if (carouselContainer) carouselContainer.kill()
})
</script>
<style lang="scss" scoped>
.main-project-carousel {
  @apply relative z-1 overflow-hidden;
  .project-carousel-inner {
    @apply main-container py-16;
    .project-carousel-container {
      @apply flex flex-row py-5 overflow-x-auto lg:overflow-visible snap-x gap-5;
      .project-carousel-card {
        @apply min-w-[320px] lg:min-w-[600px] max-w-[320px] lg:max-w-[600px]
        h-[400px] lg:h-[550px] overflow-hidden relative snap-center rounded-2xl;

        .project-carousel-card-link {
          @apply block w-full h-full relative cursor-pointer;

          .project-carousel-image {
            @apply w-full h-full object-cover transition-transform duration-500 ease-out;
          }

          .project-carousel-overlay {
            @apply absolute inset-0 pointer-events-none;
            background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.6) 0%,
              rgba(0, 0, 0, 0.1) 40%,
              transparent 60%
            );
          }

          .project-carousel-info {
            @apply absolute bottom-0 left-0 right-0 p-6 lg:p-8 z-2;

            h3 {
              @apply text-white font-FHOscar font-medium text-2xl lg:text-[36px] lg:leading-[40px] uppercase tracking-wide;
            }
          }
        }

        &:hover {
          .project-carousel-image {
            @apply scale-105;
          }
        }
      }
    }
  }
}
</style>
